import { Link } from 'react-router-dom';
import Reveal from '../../../shared/Reveal/Reveal';
import NewsletterSubscribeFeedback from '../../../shared/NewsletterSubscribeFeedback/NewsletterSubscribeFeedback';
import { useNewsletterSubscribe } from '../../../../hooks/useNewsletterSubscribe';
import { NEWSLETTER_SOURCES } from '../../../../utils/newsletterSources';
import '../../../shared/NewsletterSubscribeFeedback/NewsletterSubscribeFeedback.css';
import './Join.css';

const Join = () => {
  const {
    email,
    setEmail,
    isSubmitting,
    isSuccess,
    formError,
    fieldError,
    handleSubmit,
  } = useNewsletterSubscribe(NEWSLETTER_SOURCES.MARKET_ANALYSIS_ARTICLE);

  return (
    <section className="market-analysis-join">
      <div className="market-analysis-join__inner">
        <Reveal className="market-analysis-join__panel">
          <div className="market-analysis-join__copy">
            <h2 className="market-analysis-join__title">
              Join 2,000+ subscribers
            </h2>
            <p className="market-analysis-join__text">
              Stay in the loop with everything you need to know.
            </p>
          </div>

          <form
            className="market-analysis-join__form"
            onSubmit={handleSubmit}
            noValidate
          >
            <div className="market-analysis-join__row">
              <label className="market-analysis-join__field">
                <span className="market-analysis-join__sr-only">Email address</span>
                <input
                  className={`market-analysis-join__input${
                    fieldError ? ' newsletter-subscribe-input--error' : ''
                  }`}
                  type="email"
                  name="email"
                  value={email}
                  onChange={(event) => setEmail(event.target.value)}
                  placeholder="Enter your email"
                  autoComplete="email"
                  disabled={isSubmitting}
                />
              </label>
              <button
                type="submit"
                className="market-analysis-join__button luxury-btn"
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Subscribing…' : 'Subscribe'}
              </button>
            </div>

            <NewsletterSubscribeFeedback
              formError={formError}
              fieldError={fieldError}
              isSuccess={isSuccess}
            />

            <p className="market-analysis-join__privacy">
              We care about your data in our{' '}
              <Link to="/privacy" className="market-analysis-join__privacy-link">
                privacy policy
              </Link>
            </p>
          </form>
        </Reveal>
      </div>
    </section>
  );
};

export default Join;
